import React, { useState } from "react"
import { fullUrl } from "./types"

const FALLBACK_COLORS = ["#2563eb", "#16a34a", "#d97706", "#7c3aed", "#db2777", "#0d9488", "#ea580c", "#4f46e5"]

// Stable color per name when the user has no org color, so the same person keeps one color.
const colorFromName = (name: string) => {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) | 0
  return FALLBACK_COLORS[Math.abs(hash) % FALLBACK_COLORS.length]
}

const initials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part.charAt(0).toUpperCase())
    .join("")

interface UserAvatarProps {
  name?: string | null
  image?: string | null
  color?: string | null
  size?: number
}

const UserAvatar = ({ name, image, color, size = 40 }: UserAvatarProps) => {
  const [broken, setBroken] = useState(false)
  const label = name?.trim() || "?"
  const tint = color || colorFromName(label)
  const ring = Math.max(2, Math.round(size / 16))

  if (image && !broken) {
    return (
      <img
        className="feed-user-avatar"
        src={fullUrl(image)}
        alt={label}
        title={label}
        onError={() => setBroken(true)}
        style={{ width: size, height: size, boxShadow: `0 0 0 ${ring}px ${tint}` }}
      />
    )
  }

  return (
    <span
      className="feed-user-avatar feed-user-initials"
      title={label}
      style={{ width: size, height: size, background: tint, fontSize: Math.round(size * 0.4) }}
    >
      {initials(label)}
    </span>
  )
}

export default UserAvatar
